export const config = {
  api: {
    url: import.meta.env.VITE_API_URL || '',
  },
  keycloak: {
    url: import.meta.env.VITE_KEYCLOAK_URL || '',
    realm: import.meta.env.VITE_KEYCLOAK_REALM || '',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || '',
  },
  features: {
    quizEnabled: import.meta.env.VITE_QUIZ_ENABLED === 'true',
    /** Quando true, desativa Cronograma, Dashboard, Gerenciar Cupons e a tela Início (atividades) até o lançamento de março. Em produção usar true; em dev/homolog false. */
    marchActivitiesLocked: import.meta.env.VITE_MARCH_ACTIVITIES_LOCKED === 'true',
    adminUsersEnabled: import.meta.env.VITE_ADMIN_USERS_ENABLED === 'true',
    adminCoursesEnabled: import.meta.env.VITE_ADMIN_COURSES_ENABLED === 'true',
    adminDashboardEnabled: import.meta.env.VITE_ADMIN_DASHBOARD_ENABLED === 'true',
    adminTaxonomyEnabled: import.meta.env.VITE_ADMIN_TAXONOMY_ENABLED === 'true',
    adminUploadInBatchEnabled: import.meta.env.VITE_ADMIN_UPLOAD_IN_BATCH_ENABLED === 'true',
    assistantEnabled: import.meta.env.VITE_ASSISTANT_ENABLED === 'true',
  },
  whatsappCeiscmedPhone: import.meta.env.VITE_CEISCMED_WHATSAPP_PHONE || '+55 51 9883-7518',
};
